import React from 'react';
import { TableCell, TableRow, Typography } from '@mui/material';
import { browserTime, browserTimeZone } from 'utils/time';

// All callers supply instants; form wall times and legacy date boundaries are
// resolved at their respective entry points before reaching this display.
export default function OfferSchedule({ startAt, endAt, variant, showEmptyFields = false }) {
  const start = browserTime(startAt);
  const end = browserTime(endAt);
  const dates = [start, end].filter(date => date.isValid());
  const differentOffsets = dates.length === 2 && start.utcOffset() !== end.utcOffset();
  const zone = browserTimeZone().split('/').pop().replace(/_/g, ' ');
  const offset = dates[0]?.format('Z');
  const note = `Your local time zone: ${zone}${offset && !differentOffsets ? ` (UTC${offset})` : ''}`;
  const rows = [['Start date', start], ['End date', end]];
  const table = variant === 'table';

  return <>
    {rows.map(([label, date]) => {
      if (!showEmptyFields && !date.isValid()) return null;
      const value = date.isValid()
        ? date.format(`MM/DD/YYYY h:mm A${differentOffsets && !table ? ' [UTC]Z' : ''}`)
        : 'Not set';
      return table ? (
        <TableRow key={label}>
          <TableCell>{label}</TableCell>
          <TableCell align="right">
            {value}{' '}
            {date.isValid() && <Typography component="span" variant="body2" color="text.secondary"
              sx={{ whiteSpace: 'nowrap' }}>
              {date.format('[UTC]Z')}
            </Typography>}
          </TableCell>
        </TableRow>
      ) : (
        <Typography key={label} variant="body1" gutterBottom>
          <strong>{label}:</strong>{' '}{value}
        </Typography>
      );
    })}
    {!table && dates.length > 0 && (
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>{note}</Typography>
    )}
  </>;
}
